import { render, staticRenderFns } from "./RatingComments.vue?vue&type=template&id=34349303&scoped=true&"
import script from "./RatingComments.vue?vue&type=script&lang=js&"
export * from "./RatingComments.vue?vue&type=script&lang=js&"
import style0 from "./RatingComments.vue?vue&type=style&index=0&id=34349303&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34349303",
  null
  
)

export default component.exports